import { Route } from '@angular/router';
import { BatchComponent } from '@batch/batch.component';
import { batchFeatureKey, batchFilterInitialState, batchMetaReducers, batchReducer } from '@batch/state/batch.reducer';
import { importProvidersFrom } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { batchGuard } from '@shared/guards/batch.guard';

export const appRoutes: Route[] = [
  {
    path: 'distribution-center',
    loadChildren: () => import('./distribution-center/distribution-center.routes')
      .then( module => module.DISTRIBUTION_CENTER_ROUTES)
  },
  {
    path: 'batch',
    canActivate: [batchGuard],
    component: BatchComponent,
    providers: [
      importProvidersFrom(
        StoreModule.forFeature(
          batchFeatureKey,
          batchReducer,
          {
            initialState: batchFilterInitialState,
            metaReducers: batchMetaReducers
          }
        )
      )
    ]
  },
  {
    path: '**',
    redirectTo: 'distribution-center/package-orders',
  }
];
